import React, {useContext} from 'react';
import InputTextarea from "../../../../../components/input/input-textarea.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";
import {CorporationContext} from "../../context/corporation-context.jsx";
import {Card} from "../../../../../components/card/card.jsx";

const Cad = () => {
    const {state, setState, setChanges, dispatchHelpEnabled} = useContext(CorporationContext)

    const onChange = ({target: {value, id}}) => handleInputs(value, id)

    const handleInputs = (value, id) => {
        setState(prev => ({...prev, [id]: value}));
        setChanges(prev => (prev.includes("citizen_sos") ? prev : [...prev, "citizen_sos"]))
    }

    return (
        <Card>
            <Card.Header className={"!justify-between"}>
                <Card.Title>
                    Central de Atendimento e Despacho (CAD)
                </Card.Title>
            </Card.Header>
            <Card.Body>
                <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-12 md:col-span-6">
                        <InputForm
                            id="boName"
                            value={state.boName}
                            label="Sigla do boletim de ocorrência *"
                            onChange={onChange}
                        />
                    </div>

                    <div className="col-span-12 md:col-span-6">
                        <InputForm
                            id="fullBoName"
                            value={state.fullBoName}
                            label="Nome do boletim de ocorrência *"
                            onChange={onChange}
                        />
                    </div>
                </div>

                {dispatchHelpEnabled && (
                    <div className="mt-3">
                        <InputTextarea
                            id="dispatch_help_terms"
                            value={state.dispatch_help_terms}
                            label="Termo de responsabilidade (153 cidadão) *"
                            onChange={onChange}
                            textAreaClass="h-50"
                        />
                    </div>
                )}

            </Card.Body>
        </Card>
    );
};

export default Cad;